module.exports = __webpack_public_path__ + "f6fae1fad849f3a7abfbf5f2ddfe31f0.pdf";